"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var form_1 = require("../../../../context/form");
var useIsFilesSizeLimitExceeded_1 = __importDefault(require("./useIsFilesSizeLimitExceeded"));
var useCheckFilesMaxSize = function () {
    var _a = (0, form_1.useFormContext)(), onDeleteFile = _a.onDeleteFile, _b = _a.files, files = _b === void 0 ? [] : _b;
    var isFilesSizeLimitExceeded = (0, useIsFilesSizeLimitExceeded_1.default)();
    (0, react_1.useEffect)(function () {
        if (isFilesSizeLimitExceeded) {
            onDeleteFile(files.length - 1);
        }
    }, [
        isFilesSizeLimitExceeded,
        onDeleteFile,
        files
    ]);
};
exports.default = useCheckFilesMaxSize;
